(function ($) {
  $.fn.mdcPager = function (options) {

    var defaults = {
      counts: 1, currentPage: 1, maxPageSize: 100, pagin: {}, callback: function (page) {
      }
    };

    var settings = $.extend({}, defaults, options);

    var _this = this;
    var paginationWrapper = _this.find('.preBuiltPager');

    var first = paginationWrapper.find('span[data-pager-action="first"]');
    var next = paginationWrapper.find('span[data-pager-action="next"]');
    var previous = paginationWrapper.find('span[data-pager-action="previous"]');
    var last = paginationWrapper.find('span[data-pager-action="last"]');
    var pagenum = paginationWrapper.find('input[data-pager-action="pagenum"]');
    var pagesize = paginationWrapper.find('input[data-pager-action="pagesize"]');
    var totalRecords = paginationWrapper.find('input[data-pager-action="totalrecords"]');
    var noRecords = _this.find('.page__no--records');

    _this.init = function () {
      paginationWrapper.removeClass('d-none');
      $('.page__pagination').show();
      first.off('click').on("click", _this.firstClicked);
      next.off('click').on("click", _this.nextClicked);
      previous.off('click').on("click", _this.previousClicked);
      last.off('click').on("click", _this.lastClicked);

      pagenum.off('keydown').on('keydown', _this.numberValidation);
      pagenum.off('keyup').on('keyup', _this.maxPageNumInputValidation);
      pagenum.off('change').on("change", _this.pagenumChanged);

      pagesize.off('keydown').on('keydown', _this.numberValidation);
      pagesize.off('keyup').on('keyup', _this.maxPageSizeInputValidation);
      pagesize.off('change').on("change", _this.pagesizeChanged);

      var max_pages = Math.ceil(settings.counts / settings.pageSize);
      settings.pagin.max_pages = max_pages;
      settings.pagin.counts = settings.counts;
      settings.pagin.pagesize = settings.pageSize;
      settings.pagin.current_page = parseInt(settings.currentPage);
      settings.pagin.maxPageSize = settings.maxPageSize;
      _this.setInputval(settings.pagin.current_page, max_pages);
      totalRecords.val(settings.counts);
      pagesize.val(settings.pageSize);
      _this.setAction();
      if (settings.pagin.max_pages == 0 || isNaN(settings.pagin.max_pages)) {
        _this.disablePagination();
      } else {
        _this.enablePagination();
      }

    };
    _this.setInputval = function (pageno, totalpages) {
      pagenum.attr("placeholder", "Page " + pageno + " of " + totalpages);
    };
    _this.page = function () {
      _this.enablePagination();
      if (settings.pagin.max_pages == 0) {
        _this.disablePagination();
      }
      pagenum.attr('data-val', settings.pagin.current_page);
      pagenum.attr("placeholder", "Page " + settings.pagin.current_page + " of " + settings.pagin.max_pages).val('');
      settings.callback({"pageno": settings.pagin.current_page, "pagesize": pagesize.val()});
    };
    _this.disablePagination = function () {
      noRecords.show();
      paginationWrapper.hide();
    };
    _this.enablePagination = function () {
      noRecords.hide();
      paginationWrapper.show();
    };
    _this.disable_action = function (el) {
      el.addClass('disabled');
    };
    _this.enable_action = function (el) {
      el.removeClass('disabled');
    };
    _this.setAction = function () {
      if (settings.pagin.max_pages == settings.pagin.current_page) {
        _this.disable_action(next);
        _this.disable_action(last);
        _this.enable_action(first);
        _this.enable_action(previous);
      }
      else if (settings.pagin.current_page == 1) {
        _this.disable_action(first);
        _this.disable_action(previous);
        _this.enable_action(next);
        _this.enable_action(last);
      }
      else {
        _this.enable_action(next);
        _this.enable_action(last);
        _this.enable_action(first);
        _this.enable_action(previous);
      }
    };
    _this.firstClicked = function () {
      settings.pagin.current_page = 1;
      _this.setAction();
      _this.page();
    };

    _this.nextClicked = function () {
      settings.pagin.current_page = settings.pagin.current_page + 1;
      _this.setAction();
      _this.page();
    };

    _this.previousClicked = function () {
      if (settings.pagin.current_page > 1) {
        settings.pagin.current_page = settings.pagin.current_page - 1;
      }
      _this.setAction();
      _this.page();
    };
    _this.lastClicked = function () {
      settings.pagin.current_page = settings.pagin.max_pages;
      _this.setAction();
      _this.page();
    };
    _this.pagenumChanged = function (e) {
      settings.pagin.current_page = parseInt($(this).val());
      _this.page();
    };
    _this.pagesizeChanged = function () {
      var max_pages = Math.ceil(settings.counts / pagesize.val());
      settings.pagin.max_pages = max_pages;
      settings.pagin.current_page = 1;
      _this.setInputval(1, max_pages);
      _this.enable_action(next);
      _this.enable_action(last);
      _this.enable_action(first);
      _this.enable_action(previous);
      _this.page();
    };
    _this.numberValidation = function (e) {
      // Allow: backspace, delete, tab, escape, enter and .
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
          // Allow: Ctrl+A, Command+A
        (e.keyCode == 65 && ( e.ctrlKey === true || e.metaKey === true ) ) ||
          // Allow: home, end, left, right, down, up
        (e.keyCode >= 35 && e.keyCode <= 40)) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    };
    _this.maxPageNumInputValidation = function (e) {
      // Ensure max page number not exceeding input
      if ($(this).val() > settings.pagin.max_pages) {
        $(this).val('');
        e.preventDefault();
      }
    };
    _this.maxPageSizeInputValidation = function (e) {
      // Ensure max page size not exceeding maxPageSize
      if ($(this).val() > settings.pagin.maxPageSize) {
        $(this).val('');
        e.preventDefault();
      }
    };
    _this.init();
  };

  $.fn.mdcSort = function (options) {

    var _this = this;

    var defaults = {
      orderBy: null, orderByOrder: null, callback: function (page) {
      }
    };
    defaults.orderBy = _this.attr('data-orderBy');
    defaults.orderByOrder = _this.attr('data-orderByOrder');

    var settings = $.extend({}, defaults, options);

    var sortableColumns = _this.find('[data-sortable]');

    _this.init = function () {
      sortableColumns.off('click').on('click', _this.updateSort);
      _this.updateSortIcon();
    };

    _this.updateSortIcon = function () {
      _this.find('[data-sortable] i').removeClass('fa-sort fa-sort-up fa-sort-down').addClass('fa-sort');
      var sortableColumn = _this.find('[data-sortable="' + settings.orderBy + '"]');
      var sortIcon = settings.orderByOrder.toLowerCase() == 'asc' ? 'up' : 'down';
      $(sortableColumn).find('i').removeClass('fa-sort-up fa-sort-down').addClass('fa-sort-' + sortIcon);
      $(sortableColumn).attr('data-orderBy', settings.orderByOrder);
    };

    _this.updateSort = function (e) {
      _.isUndefined($(this).attr('data-orderBy')) ? $(this).attr('data-orderBy', 'ASC') : '';
      $(this).attr('data-orderBy') == 'ASC' ? $(this).attr('data-orderBy', 'DESC') : $(this).attr('data-orderBy', 'ASC');

      settings.orderBy = $(this).attr('data-sortable');
      settings.orderByOrder = $(this).attr('data-orderBy');

      _this.attr('data-orderBy', settings.orderBy);
      _this.attr('data-orderByOrder', settings.orderByOrder);

      _this.updateSortIcon();
      settings.callback({
        "obj": _this,
        "orderBy": settings.orderBy,
        "orderByOrder": settings.orderByOrder
      });
    };

    _this.init();
  };

})(jQuery);